import React, { useState,useEffect } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Alert from '@material-ui/lab/Alert'
import Chip from '@material-ui/core/Chip'
import InfoIcon from '@material-ui/icons/Info'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import TimerIcon from '@material-ui/icons/Timer'
import { useStyles } from './DialogValidationStyle'

import allActions from '../../../redux/actions/user'
import { useDispatch,useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import PaiementModal from '../../../components/paiement/PaiementModal'
import CountDown from '../../paiement/CountDown'


export default function AlertDialog(props) {
  
  const [codeAdherent, setcodeAdherent] = useState({ code:'',label:'' })
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const state = useSelector(state => state)
  const [currentResId, setcurrentResId] = useState('')
  const token = state.accessToken !== 'undefined' ? state.accessToken : ''
  const classes = useStyles()

  const setInvite = () => {
    setcodeAdherent({ code : '99999999', label:'INVITE' })
  }
  
  useEffect(() => {
    if(props.status === 'MODIFICATION')
    {
      if(props.guestName === '99999999')
        setcodeAdherent({ code:'99999999',label:'INVITE' })
      else
        setcodeAdherent({ code:props.codeAdherent,label:props.codeAdherent })
    }
  }, [])
  
  const handleClose = () => {
    props.close(false)
  }
  
  
  
  
  //Delete une réservation
  const unlock = async (res_id) => {
    var body = {
      userId : state.user.id,
      resId : props.res_id
    }
    const result = await allActions.fetchPostAPI(`api/reservation/unlock`,body,dispatch, token)
    enqueueSnackbar(`${result.json.message}`, { variant: result.json.variant })
    props.reload()
    handleClose()
  }
  


  
  
  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ style: { margin: 16 } }}
      >
        <DialogTitle id="alert-dialog-title">{props.titre}</DialogTitle>
        <Alert severity="error">Un problème est survenu lors de la reservation... Débloquez le créneau et effectuez une nouvelle reservation</Alert>
       
        <DialogContent>
          <div className={classes.info}>
            <Chip avatar={<InfoIcon/>} label={'Court '+props.court} variant="outlined" />
            <Chip avatar={<EventAvailableIcon/>} label={props.date.toLocaleDateString()} variant="outlined" />
            <Chip avatar={<TimerIcon/>} label={props.creneau} variant="outlined" />
          </div>
 
 
        </DialogContent>
  
        <DialogActions>
          <Button  onClick={unlock} color="primary">Débloquer</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}


// const unlock = async () => {
//   var body = {
//     userId : state.user.id,
//     resId : props.res_id,
//   }
//   const result = await allActions.fetchDeleteAPI(`api/reservation/unlock`,body,dispatch, token)
//   enqueueSnackbar(`${result.json.message}`, { variant: result.json.variant })
// }